<script lang="ts">
  import Sprite from "./sprite.svelte";
  import Timestamp from "./timestamp.svelte";
  import { sortBy } from "lodash-es";

  export let color = "inherit";
  export let title = null;
  export let showHeader = !!title;
  export let icon = null;
  export let detail = "";
  export let sortField = ["time", "timeEnd", "title"];
  export let entries = [];
  export let noMargin = false;
  export let showSubtitle = true;

  $: sorted = sortBy(entries, sortField);
</script>

{#if sorted.length}
  <table class="Status" class:no-margin={noMargin} style="--color-status: {color}">
    <thead class:sr-only={!showHeader}>
      <tr>
        <th class="StatusLabel">
          <div class="StatusLabelInner">
            {#if icon}
              <Sprite {icon} width={16} height={16} />
            {/if}
            <span class="StatusLabelTitle">{title || "Name"}</span>
          </div>
        </th>
        <th class="StatusDetail">{detail}</th>
      </tr>
    </thead>

    <tbody>
      {#each sorted as entry}
        <tr>
          <td class="StatusLabelColumn">
            <a class="ItemTitle" href={entry.href}>
              {entry.title}
              {#if showSubtitle && entry.subtitle}
                <span class="ItemSubtitle type-caption">{entry.subtitle}</span>
              {/if}
              {#if entry.statusNote}
                <i class="ItemSubtitle type-caption">{entry.statusNote}</i>
              {/if}
            </a>
          </td>
          <td class="StatusDetailColumn">
            {#if entry.startTimeIsAmbiguous && entry.endTimeIsAmbiguous}
              TBD
            {:else}
              {#if entry.time}
                {#if entry.startTimeIsAmbiguous}
                  TBD
                {:else}
                  <Timestamp time={entry.time} />
                {/if}
              {/if}

              {#if entry.time && entry.timeEnd}
                &ndash;
              {/if}

              {#if entry.timeEnd}
                {#if entry.endTimeIsAmbiguous}
                  TBD
                {:else}
                  <Timestamp time={entry.timeEnd} />
                {/if}
              {/if}
            {/if}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
{/if}

<style>
  .Status {
    border-collapse: collapse;
    width: 100%;
  }

  .Status:not(:first-child) {
    margin-top: 24px;
  }

  .Status.no-margin {
    margin-top: 0;
  }

  .Status th {
    background: var(--color-status);
    color: white;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.05em;
    line-height: 1;
    padding: 8px 12px;
  }

  .Status td {
    vertical-align: baseline;
  }

  th.StatusLabel {
    border-top-left-radius: 8px;
    text-align: left;
    padding-left: 8px;
  }

  th.StatusDetail {
    border-top-right-radius: var(--border-radius-small);
  }

  .StatusLabelTitle {
    padding-left: 6px;
  }

  .StatusLabelInner {
    display: flex;
    line-height: 16px;
    align-items: center;
  }

  .StatusDetail {
    border-bottom-right-radius: var(--border-radius-large);
    text-align: right;
    text-transform: uppercase;
  }

  .StatusLabelColumn {
    box-shadow: inset 2px 0 var(--color-status);
    line-height: 1;
    padding: 0 0 0 22px;
  }

  .StatusDetailColumn {
    text-align: right;
    padding: 8px 8px 0;
    white-space: nowrap;
  }

  tr:first-child .StatusLabelColumn,
  tr:first-child .StatusDetailColumn {
    padding-top: 8px;
  }

  .ItemTitle {
    display: block;
    padding: 8px 8px 8px 0;
    text-decoration: none;
  }

  .ItemSubtitle {
    display: block;
    margin-top: 4px;
  }
</style>
